import { render, staticRenderFns } from "./tenant_user_table.vue?vue&type=template&id=72b9d226&"
import script from "./tenant_user_table.vue?vue&type=script&lang=js&"
export * from "./tenant_user_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports